<div class="label-container" [ngClass]="labelStyle">
    <span class="text">{{ text | translate }}</span>
    <img class="border-right" />
</div>
